"use client";

import React, {
  useRef,
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import {
  Autoplay,
  Pagination,
  Navigation,
  Zoom,
  EffectFade,
} from "swiper/modules";
import { assign, cloneDeep } from "lodash";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/zoom";
import "swiper/css/effect-fade";
const optionsDefault = {
  effect: "slide",
  zoom: true,
  loop: true,
  autoplay: {
    delay: 1000,
    disableOnInteraction: true,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
};

const Banner = forwardRef(
  ({ options, controls = {}, slides = [], children, onChangeIndex }, ref) => {
    const [slideList, setSlideList] = useState(cloneDeep(slides));
    const [swiper, setSwiper] = useState();
    const swiperOptions = options
      ? assign({}, optionsDefault, options)
      : cloneDeep(optionsDefault);

    useEffect(() => {
      setSlideList(cloneDeep(slides));
    }, [slides]);

    useImperativeHandle(ref, () => ({
      slideTo: (index) => {
        swiper.slideTo(index);
      },
      slideNext: () => {
        swiper.slideNext();
      },
      slidePrev: () => {
        swiper.slidePrev();
      },
    }));

    const handleSlideChange = (swiper) => {
      if (onChangeIndex) {
        onChangeIndex(swiper.activeIndex);
      }
    };

    const modules = [EffectFade, Autoplay, Pagination, Navigation];
    if (swiperOptions.zoom) {
      modules.push(Zoom);
    }

    const showPagination = controls.withPagination !== false;
    const showNavigation = controls.withNavigation !== false;
    return (
      <div className="banner-swiper" suppressHydrationWarning={true}>
        <Swiper
          onSwiper={(swiper) => {
            setSwiper(swiper);
          }}
          className="swiper"
          modules={modules}
          loop={swiperOptions.loop}
          effect={swiperOptions.effect}
          autoplay={swiperOptions.autoplay}
          spaceBetween={swiperOptions.spaceBetween}
          breakpoints={swiperOptions.breakpoints}
          speed={swiperOptions.speed}
          zoom={swiperOptions.zoom}
          pagination={showPagination ? { clickable: true } : false}
          navigation={showNavigation}
          onSlideChange={handleSlideChange}
        >
          {slideList.map((slide, index) => {
            const slideKey = slide?.id || slide?.key || `slide-${index}`;
            return (
              <SwiperSlide key={slideKey}>
                {children ? children({ slide: { item: slide, index } }) : null}
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    );
  }
);

Banner.displayName = "Banner";

export default Banner;
